import { Avatar, Box, Chip, Typography, useTheme } from "@mui/material"
import { CustomIcon } from "components/icons"
import { FeatureListItem } from "components/domains/features"
import { ShopIcon } from "../../icons"
import { useTranslation } from "providers/i18n"
import { useMemo } from "react"
import { getFeatureDetail } from "utils/feature"
import _ from "lodash"

export const SearchListItem = ({
  data: feature,
  primaryTypographyProps = {},
  secondaryTypographyProps = {},
  ...props
}) => {
  const { t } = useTranslation()
  //TODO:: implement condition later
  const { primary, avatarProps, isAd = false, feature_type } = feature
  const { category, level, zone, venueName } = getFeatureDetail(feature)

  const categoryText = useMemo(() => t(category), [category, t])
  const venueText = useMemo(() => t(venueName)?.toUpperCase(), [venueName, t])
  const levelText = level && `${t(level)}`
  const zoneText = zone && `${t("Zone")} ${t(zone)}`

  const secondaryText = useMemo(
    () =>
      _.compact([
        _.compact([t(venueText), levelText]).join(" - "),
        zoneText || categoryText,
      ]).join(" | "),
    [levelText, t, venueText, zoneText, categoryText]
  )

  const isSection = feature_type === "section"

  const theme = useTheme()
  const styles = theme.components[`VuiSearchResultItem`]?.styleOverrides || {}
  const { adChip, zoneChip, primaryWrapper, secondaryWrapper } = styles

  return (
    <FeatureListItem
      divider
      disableTypography
      primary={
        <Box sx={primaryWrapper}>
          <Typography
            variant="h6"
            className="MuiListItemText-primary"
            {...primaryTypographyProps}
          >
            {primary}
          </Typography>
          {isAd && (
            <Chip
              variant="contained"
              label={t("sponsored.search_result")}
              sx={adChip}
            />
          )}
        </Box>
      }
      secondary={
        <Box sx={secondaryWrapper}>
          {isSection && (
            <Chip variant="contained" label={t("Zone")} sx={zoneChip} />
          )}
          <Typography
            variant="subtitle1"
            className="MuiListItemText-secondary"
            {...secondaryTypographyProps}
          >
            {secondaryText}
          </Typography>
        </Box>
      }
      avatar={
        <Avatar src={avatarProps.src} variant="logo">
          {/* if there is no avatar, will fall back to categoryIconPath > ShopIcon */}
          {avatarProps.path ? (
            <CustomIcon path={avatarProps.path} />
          ) : (
            <ShopIcon />
          )}
        </Avatar>
      }
      className={isSection ? "section-card" : ""}
      //TODO: add Adornment prop
      {...props}
    />
  )
}
